import loadable from '../../utilities/loadable'

export const ShippedItemInfo = loadable(() => import('./ShippedItemInfo'))
